<script lang="ts" setup>
import Popover from 'primevue/popover';
import { computed, ref } from 'vue';
import { useApplicationRoot } from '@tools/applicationRoot';

export interface VPopoverProps {
  theme?: 'primary' | 'dark';
  role?: 'tooltip' | 'dialog';
}

const props = withDefaults(defineProps<VPopoverProps>(), {
  theme: 'primary',
  role: 'dialog',
});

const popover = ref();
const applicationroot = useApplicationRoot();

defineExpose({
  hide: () => popover.value.hide(),
  show: (event: Event) => popover.value.show(event),
  toggle: (event: Event) => popover.value.toggle(event),
  visible: computed(() => popover.value?.visible),
});
</script>

<template>
  <!-- @vue-expect-error theme bestaat expliciet niet maar impliciet wel-->
  <Popover
    :append-to="applicationroot"
    ref="popover"
    :pt="{ root: { role: props.role } }"
    :theme="props.theme"
  >
    <slot></slot>
  </Popover>
</template>
